import {observable, action} from 'mobx';
import {score, finance, time} from '../index';
import Parent from './parent';
import settings from '../cultureSettings.json';


export default class DryingUnit extends Parent{
    @observable percents;
    @observable speed;

    constructor(num, DCName='',culturePercents,speed,status='' ,culture='None',amount=0,waste=0,moisture=0,capacity=1000,scenario=[]){
        super(num, culture, scenario, amount, moisture, waste, status,DCName);
        this.culturePercents = culturePercents;
        this.speedParams = speed;
        this.speed = 0;
        this.type="drying"
    }

    @action shippingFrom(speed){
        if(this.culture!=='None' && this.amount > 0) {
            super.shippingFrom(this.amount)
        }
    }

    @action setUnit(amount=0, culture="None", moisture=0, waste=0, active=false){
        super.setUnit(amount, culture, moisture, waste, active)
        this.speed=0;
    }
    @action filling(culture,delta,waste,moisture){
        super.filling(culture,delta,waste,moisture);
        this.setMoistureLevel()
    }

    @action setMoistureLevel(){
        if(this.moistureLevel > settings[this.culture].baseMoisture) {
                // let coef = Math.floor(((this.moistureLevel < (settings[this.culture].baseMoisture * 0.7)) ?
                //         (this.culturePercents[this.culture].min * 0.2)
                //         :
                //         ((this.moistureLevel < (settings[this.culture].baseMoisture)) ?
                //                 (this.culturePercents[this.culture].min)
                //                 :
                //                 (this.moistureLevel >= settings[this.culture].critMoisture ?
                //                         this.culturePercents[this.culture].max
                //                         :
                //                         ((((this.moistureLevel - settings[this.culture].critMoisture) * (this.moistureLevel - settings[this.culture].critMoisture)) *
                //                             (this.culturePercents[this.culture].min - this.culturePercents[this.culture].max)) /
                //                             ((settings[this.culture].critMoisture - settings[this.culture].baseMoisture) * (settings[this.culture].critMoisture - settings[this.culture].baseMoisture))) +
                //                         this.culturePercents[this.culture].max
                //                 )
                //         )
                // ) * 100) / 100;

                // if (this.moistureLevel <= coef || (this.moistureLevel - coef) < settings[this.culture].baseMoisture) {
                //     finance.incDCParams('drying', this.culture, this.amount, this.moistureLevel);
                //     this.moistureLevel = settings[this.culture].baseMoisture;
                // } else {
                //     finance.incDCParams('drying', this.culture, this.amount, coef);
                //     this.moistureLevel -= coef;
                // }
            finance.incDCParams('drying', this.culture, this.amount, ((this.moistureLevel - settings[this.culture].baseMoisture > 0 ?
                        this.moistureLevel - settings[this.culture].baseMoisture: 0))
            );
                this.moistureLevel = settings[this.culture].baseMoisture
            }
    }
    @action setSpeed(speed){
        this.speed = speed;
    }
}


// WEBPACK FOOTER //
// ./src/shared/stores/objects/DryingUnit.js